module.exports = __webpack_public_path__ + "static/media/rack-and-pinion.e6aa5bdb.svg";